import { render } from "./Fp_pageLink.vue?vue&type=template&id=c3ec72f4&scoped=true"
import script from "./Fp_pageLink.vue?vue&type=script&lang=js"
export * from "./Fp_pageLink.vue?vue&type=script&lang=js"

import "./Fp_pageLink.vue?vue&type=style&index=0&id=c3ec72f4&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ec72f4"]])

export default __exports__